import { render, staticRenderFns } from "./centrifuge.vue?vue&type=template&id=513f9658&scoped=true&"
import script from "./centrifuge.vue?vue&type=script&lang=js&"
export * from "./centrifuge.vue?vue&type=script&lang=js&"
import style0 from "./centrifuge.vue?vue&type=style&index=0&id=513f9658&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "513f9658",
  null
  
)

export default component.exports